export default __webpack_public_path__ + "dist/media/Process.7f3ab229.svg";